exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".original-price{margin-left:0;font-size:16px;color:#999}.dropdown{position:relative;display:inline-block;text-align:center;margin-top:auto;margin-bottom:auto}.dropdown-content{display:none;position:absolute;width:200px;background-color:#f9f9f9;box-shadow:0 8px 16px 0 rgba(0,0,0,.2);z-index:1}.dropdown:hover .dropdown-content{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-58cab2d2","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/app/main/components/MainPage.vue
// module id = 259
// module chunks = 2